import { render, staticRenderFns } from "./USPAEntry.vue?vue&type=template&id=65fe86c8&scoped=true&"
import script from "./USPAEntry.vue?vue&type=script&lang=js&"
export * from "./USPAEntry.vue?vue&type=script&lang=js&"
import style0 from "./USPAEntry.vue?vue&type=style&index=0&id=65fe86c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe86c8",
  null
  
)

export default component.exports